import { useAtom } from "@reatom/npm-react"

import { Label, Select } from "ui-kit/components-branded"
import { sexAtom } from "modules/PsyCatalog/common/models/filterForm"

export function SexSelector() {
    const [value] = useAtom(sexAtom.inputValue)
    return (
        <>
            <Label htmlFor="sex" className="label-with-opacity">
                Пол
            </Label>
            <Select
                name="sex"
                id="sex"
                onChange={sexAtom.onChange}
                value={value}
                className="is-fullwidth"
                options={[
                    { value: "F", label: "Женский" },
                    { value: "M", label: "Мужской" },
                    { value: "any", label: "Любой" },
                ]}
            />
        </>
    )
}
